import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "swiper/dist/css/swiper.min.css";
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
Vue.use(ElementUI);



/****** 全局注册axios ******/
import axios from 'axios';
Vue.prototype.axios = axios;




import goods from './components/goods.vue'
Vue.component('goods', goods);

var alert_error = function(msg = '信息错误,返回首页!') {
this.$confirm(msg, '提示', {
confirmButtonText: '确定',
type: 'warning',
showCancelButton: false,
center: true
}).then(() => {
this.$router.push({path: '/index'})

})
}
Vue.prototype.alert_error = alert_error;

var jump = function(path, query = {}) {
if (!path) {
return false;
}
this.$router.push({
path: path,
query: query
});
}
Vue.prototype.jump = jump;
/****** 全局注册vux组件 ******/
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

Vue.directive('transfer-dom', TransferDom);
Vue.component('cell', Cell);
Vue.component('toast', Toast);
Vue.component('alert', Alert);
Vue.component('confirm', Confirm);
Vue.component('group', Group);
Vue.component('cell-box', CellBox);
Vue.component('actionsheet', Actionsheet);

Vue.filter('formatTimeStamp', function (value) {
console.log(value);
if (value == undefined || parseInt(value) == 0){
return ""
}

var time = new Date(value*1000);
var y = time.getFullYear();
var m = time.getMonth()+1;
if (m < 10){
m = '0'+m;
}
var d = time.getDate();
if (d < 10){
d = '0'+d;
}
var h = time.getHours();
if (h < 10){
h = '0'+h;
}
var mm = time.getMinutes();
if (mm < 10){
mm = '0'+mm;
}
var s = time.getSeconds();
if (s < 10){
s = '0'+s;
}
return y+'-'+m+'-'+d+' '+h+':'+mm+':'+s;
})

/****** 全局处理错误提示、数据加载 ******/
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);


Vue.config.productionTip = false;


const app = new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js